@let items = (workerStatusOptions$ | async) ?? [];

<lib-select
  [style.height.%]="100"
  [options]="items"
  [formControl]="control"
  [labelTranslateKey]="labelTranslateKey"
  [isClearable]="isClearable"
  [fullWidth]="fullWidth"
  [isOptionListLoading]="workerStatusDictionaryService.isLoading()"
/>
